import React from 'react';
import { defineCommand } from '../../../../../concepts/commands/CommandDefinition';
import { IsolatedObjectManager } from '../../../../../concepts/objects/IsolatedObjectManager';
import { ContentInjector } from '../../../../canvas/injection/ContentInjector';
import { DeqoData } from '../../../../canvas/injection/DeqoData';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { Zone } from '../../../zones/Zone';
import { useAssitantToolCallResult } from '../../AssistantHooks';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const AddZonesToolCallView = React.memo(({ toolCallId }: ToolCallPart) => {

    const result = useAssitantToolCallResult(toolCallId) as any;

    return <Flexer padding=".5">
        <Copy flush>
            {result?.message ?? 'Working...'}
        </Copy>
    </Flexer>;
});

export const AddZonesToolSupport = AssitantToolSupport({
    toolName: 'addZones',
    ui: AddZonesToolCallView,
    command: defineCommand(
        'assitantAddZones',
        null,
        (cc, [args]: [any]) => {

            const { spec } = args;
            const injector = cc.resolve(ContentInjector);

            const iom = new IsolatedObjectManager();
            const tuples = spec.map(s => {
                const zone = iom.create(Zone);
                zone.title = s.title;
                zone.x = s.left;
                zone.y = s.top;
                zone.width = s.width;
                zone.height = s.height;
                zone.autoColor = s.color;
                return zone.toTuple();
            });

            const data = DeqoData.wrap(tuples);
            injector.injectNative(data, { focus: 'animate', space: 200, place: true });

            return { ok: true, message: `Added ${tuples.length} zones to the board.` };
        }
    )
});
